import { gql } from '@apollo/client';

/**
 * Whether this member should be shown the welcome modal. `welcomeStatus` is
 * absent for accounts predating it, which is how they are never shown it.
 *
 * Its own query rather than a field on the homepage's shared one, which uses
 * `errorPolicy: 'none'` — a failure here would take the whole page's `User`.
 */
export const WELCOME_MODAL_STATUS_QUERY = gql`
  query WelcomeModalStatus {
    user {
      id
      firstName
      activationDate
      onboarding {
        welcomeStatus
      }
    }
  }
`;

/** Records what the member did, so the modal is shown only once. */
export const SET_WELCOME_MODAL_STATUS_MUTATION = gql`
  mutation SetWelcomeModalStatus($userInput: UpdateUserInput!) {
    updateUser(userInput: $userInput)
  }
`;
